module.exports = __webpack_public_path__ + "static/media/Concept_HouseInteriors_01.defb2092.jpg";